module.exports = __webpack_public_path__ + "media/dashboard/assets/images/kata/channel-icon-ab7a0385a68ce8a8f23b48f21c2a133f.svg";